module.exports = __webpack_public_path__ + "static/media/patterns.96537176.JPG";